<template>
	<div class="container">
		<div class="form__wrapper">
			<div class="form__title">
				Log In
			</div>
			<div class="form__body">
				<div v-if="getErrorMessage" class="alert alert-danger" role="alert">
					{{getErrorMessage}}
				</div>
				<div v-else-if="verification.status" class="alert" :class="verification.class" role="alert">
					{{ verification.message }}
				</div>
				<form @submit.prevent="loginUser">
					<div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="email">Email Address</label>
								<input
									id="email"
									class="form-control"
									placeholder="Email Address"
									type="email"
									v-model="itemData.email"
									:class="[{'is-invalid': errors.email}]"
									@keydown="clearErrors($event.target.name)">
								<div class="invalid-feedback">
									{{ errors.email }}
								</div>
							</div>
						</div>
					</div>

					<div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="password">Password</label>
								<input
									id="password"
									class="form-control"
									placeholder="*********"
									type="password"
									v-model="itemData.password"
									:class="[{'is-invalid': errors.password}]"
									@keydown="clearErrors($event.target.name)">
								<span>
									<router-link
										class="form-link"
										:to="{name: 'forgot-password'}">
										Forgot password?
									</router-link>
								</span>
								<div class="invalid-feedback">
									{{ errors.password }}
								</div>
							</div>
						</div>
					</div>

					<div class="btn__group btn__group--form">
						<button
							v-bind="{'disabled': loading}"
							@click.prevent="loginUser"
							type=submit
							class="btn__primary btn__primary--main">Sign In</button>
					</div>
				</form>

			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import form from '../mixins/form';
import auth from '../utils/validations/auth';

export default {
	name: 'Login',
	mixins: [form],
	data() {
		return {
			itemData: {},
			errors: {},
			loading: false,
			verification: {
				status: false,
				class: null
			}
		};
	},
	computed: {
		...mapGetters([
			'isLoggedIn',
			'getStatus',
			'getLoggedUser',
			'getLogError',
			'getErrorMessage'
		])
	},
	created() {
		this.reset();
	},
	watch: {
		isLoggedIn(newValue) {
			if (newValue) {
				setTimeout(() => {
					this.$router.push({ name: 'dashboard', params: { id: this.getLoggedUser.id } });
				}, 1000);
			}
		},
		getStatus(value) {
			if (value === 'error') {
				this.loading = false;
			}
		}
	},
	methods: {
		...mapMutations([
			'reset'
		]),
		...mapActions([
			'login'
		]),
		loginUser() {
			this.validate(this.itemData, auth.login);
			if (Object.keys(this.issues).length) {
				this.errors = this.issues;
				return false;
			}
			this.loading = true;
			this.login(this.itemData);
			return true;
		}
	},
	mounted() {
		const url = new URLSearchParams(window.location.search);
		if (url.get('verification') !== undefined && url.get('verification') === 'success') {
			this.verification.status = true;
			this.verification.message = 'Your account verification was successful. Please login.';
			this.verification.class = 'alert-success';
		} else if (url.get('verification') !== undefined && url.get('verification') === 'fail') {
			this.verification.status = true;
			this.verification.message = 'Your account verification was not successful';
			this.verification.class = 'alert-danger';
		}
	}
};
</script>

<style lang="scss" scoped>
	.btn__group--form {
		margin-top: 30px;
		text-align: center;
	}
	.btn__primary--main {
		width: 230px;
	}
	.form-link {
		color: $grey;
	}
</style>
